var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth0.error)?_c('h1',[_vm._v(_vm._s(_vm.$auth0.error.message))]):_c('h5',[_vm._v("Please wait ...")])}
var staticRenderFns = []

export { render, staticRenderFns }